import { onboardingStorageKeys } from '@app/features/quick-start/constants';
import type { FlowSteps } from '@app/features/quick-start/data';

type HandleUploadOnboardingParams = { stepName: FlowSteps };

const handleUploadOnboarding = async (completeStep: (args: HandleUploadOnboardingParams) => void) => {
    const { finished, path, activeStep } = window.onboardingFlow;
    const sampleUploadStep = ['sample', 'empty'].includes(path) && activeStep === '4';
    const gitFlowOrUploadFlowUploadStep = (path === 'git' || path === 'upload') && activeStep === '5';

    if (!finished && (sampleUploadStep || gitFlowOrUploadFlowUploadStep)) {
        await completeStep({
            stepName: activeStep,
        });

        localStorage.setItem(onboardingStorageKeys.modal, 'true');
    }
};

export default handleUploadOnboarding;
